import { App } from '../App';
import { formatNumberToLocale } from './formatNumberToLocale';

export function formatNumberWithSuffix(
  number: number,
  suffix: string,
  precision?: number,
): string {
  const { nbspSymbol } = App.config.formatting;
  const prepend = formatNumberToLocale(number, { precision });

  return `${prepend}${nbspSymbol}${suffix}`;
}
